import React, {useContext, useState} from 'react';
import {Button, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown} from "reactstrap";
import BuyCreditsicon from "../../assets/images/icons/BuyCreditsicon.svg"
import {GoThreeBars} from "react-icons/go";
import {Link} from "react-router-dom";
import authContext from "../../AuthProvider/authContext";
import MobileSideCanvas from "../Sidebar/MobileSideCanvas";
import localized from "../../i18n";
import us from "../../assets/images/icons/united-states.png";
import fr from "../../assets/images/icons/france.png";
import barImage from "../../assets/images/bar.svg"
import dropDown from "../../assets/images/dropdown.svg"
import HandIcon from "../../assets/images/handIcon.png"

const DashboardHeader = () => {
    const {state,updateAuth} = useContext(authContext);
    const {auth, total} = state;
    const [openMobileSidebar, setOpenMobileSidebar] = useState(false);
    const toggleMobileSidebar = () => {
        setOpenMobileSidebar(!openMobileSidebar);
    }
    const changeLanguage = (event) => {
        updateAuth({lang: event.target.value});
        localStorage.setItem('lang', event.target.value);
        localized.setLanguage(localStorage.getItem('lang'));
    }

    return (
        <div className={"dashboard-header"}>
        <div className="dashboard-header-container">
            {auth.role === 1 &&
            <div className="dashboard-header-inner">
                <div className="toggle-sidebar-icon" onClick={toggleMobileSidebar}>
                    <img src={barImage}/>
                </div>
                <div className="dashboard-heading">
                    <h1>{localized.Welcome} {auth.first_name}! </h1>
                    <p className="mb-0">{localized.Lets_check_emails_now}</p>
                </div>
            </div>}
            {auth.role===2 &&
                <>
                    <div className={"d-flex d-sm-none align-items-center justify-content-between dashboard-name-container"}>
                        <div className="toggle-sidebar-icon" onClick={toggleMobileSidebar}>
                            <img src={barImage}/>
                        </div>
                        <Link to={"/pricing-plan"}>
                            <Button className="btn-block secondary-btn">
                                <div><img src={BuyCreditsicon} alt="Buy Credits"/></div>
                                <div>{localized.Buy_Credits}</div>
                            </Button>
                        </Link>
                    </div>
            <div className="dashboard-header-inner justify-content-between">
                <div className="dashboard-heading">
                    <h1>{localized.Welcome} {auth.first_name}! <img src={HandIcon} height={22}/></h1>
                    <p className="mb-0">{localized.Lets_check_emails_now}</p>
                </div>
                <div className="sidebar-nav-link d-block d-sm-none">
                    <div className="sidebar-nav-title">
                        <UncontrolledDropdown className="user_action language-change">
                            <DropdownToggle className="sidebar-nav-caret d-flex align-items-center" caret>
                                {(state.lang === "en") ? <img src={us} alt={"us-flag"} className={"flag-icon"} style={{width:"20px"}}/> : <img src={fr} className={"flag-icon"} alt={"fr-flag"} style={{width:"20px"}}/>}<img src={dropDown} alt={"fr-flag"} style={{width:"16px"}} className={"dropdown-icon"}/>
                            </DropdownToggle>
                            <DropdownMenu value={state.lang}>
                                <DropdownItem className="active-flag" value="en" onClick={changeLanguage}>
                                    English
                                </DropdownItem>
                                <DropdownItem className="active-flag delete_user" value="fr" onClick={changeLanguage}>
                                    French
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center flex-sm-nowrap flex-wrap header-right-side-container">
                <div className={"credit-limit"}>
                    <div>{localized.Credits_Available}</div>
                    <div className={"count"}><div>{auth.available_credit ? auth.available_credit : "0"}</div></div>
                </div>
                <Link to={"/pricing-plan"} className={"d-none d-sm-block"}>
                    <Button className="btn-block secondary-btn">
                        <div><img src={BuyCreditsicon} alt="Buy Credits"/></div>
                        <div>{localized.Buy_Credits}</div>
                    </Button>
                </Link>
                <div className="sidebar-nav-link d-none d-sm-block">
                    <div className="sidebar-nav-title">
                        <UncontrolledDropdown className="user_action language-change">
                            <DropdownToggle className="sidebar-nav-caret d-flex align-items-center" caret>
                                {(state.lang === "en") ? <img src={us} alt={"us-flag"} style={{width:"20px"}} className={"flag-icon"}/> : <img src={fr} alt={"fr-flag"} style={{width:"20px"}} className={"flag-icon"}/>}{state.lang === "en" ? 'English' : 'Français'}<img src={dropDown} alt={"fr-flag"} style={{width:"16px"}} className={"dropdown-icon"}/>
                            </DropdownToggle>
                            <DropdownMenu value={state.lang}>
                                <DropdownItem className="active-flag" value="en" onClick={changeLanguage}>
                                    English
                                </DropdownItem>
                                <DropdownItem className="active-flag delete_user" value="fr" onClick={changeLanguage}>
                                    French
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </div>
                </div>
            </div>
            </>
            }
            <MobileSideCanvas
                isOpen={openMobileSidebar}
                toggle={toggleMobileSidebar}
            />
            {auth.role === 1 &&
            <div className="">
                <div className="amount_payout">
                        <span className="price">
                            <span className="payout">Total Users : </span>
                            <span className="amount">{total.active + total.inActive || 0}</span>
                        </span>
                    <span className="price_summery">
                            <span className="processing_fee">Active Users :</span>
                            <span className="amount">{total.active || 0}</span>
                        </span>
                    <span className="price_summery">
                            <span className="total">InActive Users : </span>
                            <span className="amount">{total.inActive || 0}</span>
                        </span>
                </div>
            </div>
            }
        </div>
        </div>
    );
};

export default DashboardHeader;